module.exports = __webpack_public_path__ + "images/cebsb_logo.1788405320306.png";